// extracted by mini-css-extract-plugin
export default {"updateNotification":"styles_updateNotification__tYPFe","closeModalButtonContainer":"styles_closeModalButtonContainer__emi7S","closeModalButton":"styles_closeModalButton__2e5dP"};